import { ICrmField, ICrmParameter } from '@/features/dataSourceEdit/types';
import { FC, PropsWithChildren } from 'react';
import { CheckInstallationMessage } from './CheckInstallationMessage';

type CheckInstallationListProps = {
  listItems: ICrmParameter[] | ICrmField[];
  empyListMessage: string;
} & PropsWithChildren;

export const CheckInstallationList: FC<CheckInstallationListProps> = ({ listItems, empyListMessage, children }) => {
  if (!listItems || listItems.length === 0) {
    return (
      <ul className='list-inside list-disc'>
        <CheckInstallationMessage asListItem>{empyListMessage}</CheckInstallationMessage>
      </ul>
    );
  }

  return <ul className='list-inside list-disc'>{children}</ul>;
};
